export default __webpack_public_path__ + "static/serhii-nazarchuk-dcb002723844d82d114a240bb78296cf.png";